<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ['hasoffers','offerlook','affise','hugoffers','offershub','offer18','fuseclick','trackier','eflow','partners','swaarm','clicks9', 'offerfeed', 'eagle', 'orangear', 'algambo','gim','sapphyre','convertingforce','vaca','datamaths','movable','avaliableOffers','adosiz','pia','hakuna','offersmeta','offerborn'].map(v => {
			return { value: v, label: v };
		});
		return{
			options,
		}
	},
	async mounted(){
		const enumList = await this.getEnum();
		enumList.forEach((row) => {
			const item = this.options.find((r) => {
				return r.value == row.value;
			});
			if (!item) {
				this.options.push(row);
			}
		})
	},
  methods: {
    async getEnum() {
			if(!this.$cache['track_platform_dict_list']) {
				const res = await this.$post('/dict/selectList',{
          type: 'track_platform',
        })
        this.$cache['track_platform_dict_list'] = res.map((row) => {
          return { value: row.name, label: row.name };
        });
			}
			return this.$cache['track_platform_dict_list'];
    }
  },
	props:['value'],
}
</script>

